import { useState } from 'react';

import type { PurchaseWebContract } from '@xing-com/crate-common-graphql-types';
import { getContractPrice, useInstance } from '@xing-com/crate-upsell-utils';

import type { ActiveContract } from '../typings';
import { ensure } from '../utils/ensure';

export interface UseContracts {
  activeContract: ActiveContract;
  toggleContract: (id: string) => void;
}

export function useContracts(contracts: PurchaseWebContract[]): UseContracts {
  const [activeContractId, setActiveContract] = useState(() => {
    return contracts.reduce((acc, cur) =>
      cur.initialDuration > acc.initialDuration ? cur : acc
    ).id;
  });

  const activeContract = ensure(
    contracts.find(({ id }) => id === activeContractId)
  );

  const toggleContract = (id: string): void => setActiveContract(id);

  return {
    activeContract: {
      ...activeContract,
      price: getContractPrice(activeContract),
      isBestSeller: useInstance(activeContractId) === activeContractId,
    },
    toggleContract,
  };
}
